import React from 'react';
import { Button, Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    footerContainer: {
        background: 'rgba(244, 244, 244, 1)',
        padding: '10px',
        textAlign: 'right',
        height: "46px",
    },
    buttonRejeter: {
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600,
        lineHeight: '16.14px',
        textAlign: 'left',
        color: 'rgba(255, 54, 54, 1)',
        background: 'rgba(255, 229, 229, 1)',
        width: '62px',
        height: '26px',
        borderRadius: '5.38px',
        marginRight: '10px',
        '&:hover': {
            background: 'rgba(255, 229, 229, 1)',
        },
    },
    buttonValider: {
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600,
        lineHeight: '16.14px',
        textAlign: 'left',
        color: 'rgba(255, 255, 255, 1)',
        background: 'rgba(60, 101, 86, 1)',
        width: '61.08px',
        height: '26.71px',
        borderRadius: '5.38px',
        marginRight: "10px",
        '&:hover': {
            background: 'rgba(60, 101, 86, 1)',
        },
    },
}));

const FooterButtons = () => {
    const classes = useStyles();

    return (
        <Grid container justifyContent="flex-end" className={classes.footerContainer}>
            <Button className={classes.buttonRejeter}>Rejeter</Button>
            <Button className={classes.buttonValider}>Valider</Button>
        </Grid>
    );
};

export default FooterButtons;
